<ng-container *ngIf="agChartOptions">
  <ag-charts-angular
    [options]="agChartOptions"/>
</ng-container>
